const companies = [
  {
    type: 'nontimeline',
    avatar: 'https://github.com/amabes.png?size=128',
    title: 'Alan Mabry',
    orientation: 'right',
    body: `
I started building web apps in 2008. Before that I was designing websites and pursuing a BFA.

I'm framework agnostic, but prefer React & NextJs to build enterprise web applications.

Currently, I'm at [CLEAR](https://www.clearme.com/business-and-partnerships) building identity verification applications used by Fortune 500 companies including [AVIS](https://www.clearme.com/partners/avis) and [LinkedIn](https://www.clearme.com/partners/linkedin).

At my previous position, I worked at [Total Brain](https://totalbrain.com), a platform to improve mental health and monitor brain performance.

My go to tech includes Javascript, React, NodeJS and Cypress.

The examples below are highlights from the past 10+ years and some current endeavors.

[See my LinkedIn profile](https://www.linkedin.com/in/alanmabry) for more career details.
`
  },
  {
    type: 'header',
    avatar: 'imgs/projects/clear/clear-avatar.jpeg',
    title: 'CLEAR',
    body: `
[clearme.com](https://clearme.com/)

Software Engineer III
    `,
    dates: 'Feb 2022 - Current',
    orientation: 'right'
  },
  {
    type: 'nontimeline',
    title: 'CLEAR Check-in',
    body: `
Helped build out Verify with CLEAR, a centralized identity platform, using Next/React/TS and an embeddable button for clients to integrate in their websites.

Built internal tools to emulate client integration that enabled engineers to develop more efficiently and test more effectively with Cypress.

Worked with Mitek & iProov for face capture and wrote integrations for SplunkRum to give better E2E visibility.
  `,
    orientation: 'right',
    projects: [
      {

        screens: [
          {
            img: 'imgs/projects/clear/clear-check-in-how-it-works.png'
          },
          {
            img: 'imgs/projects/clear/clear-web-verify.gif',
            height: '600px',
          }
        ]
      }
    ]
  },
  {
    type: 'header',
    avatar: 'imgs/projects/total-brain/total-brain-avatar.jpeg',
    title: 'Total Brain',
    body: `
[totalbrain.com](https://www.totalbrain.com/)

Sr. Software Engineer, Front End
    `,
    dates: 'May 2019 - Feb 2022',
    orientation: 'right'
  },
  {
    type: 'nontimeline',
    title: 'Total Brain Platform',
    body: `


Worked on numerous React apps, developed integration methods for our clients and helped convert our monolithic app into micro services.

Integrated Contentful throughout our apps to support multiple languages and give our product team members more control over the text/image content in our apps.

Conceived and created internal tools to speed up development and streamline our customer service workflows.
  `,
    orientation: 'right',
    projects: [
      {

        screens: [
          {
            img: 'imgs/projects/total-brain/total-brain-overview.png',
          }
        ]
      }
    ]
  },
  {
    type: 'nontimeline',
    orientation: 'right',
    projects: [
      {

        screens: [
          {
            img: 'imgs/projects/total-brain/total-brain-home-feed.jpeg',
            body: 'Built a home feed that serves up brain activities based on our AI recommendation engine.'
          },
          {
            img: 'imgs/projects/total-brain/total-brain--phaser-react-integration.jpeg',
            body: 'Helped create a React x Phaser JS middleware to reduce redundancies and improve end user experience while interacting with our brain games and meditations.'
          }
        ]
      }
    ]
  },
  {
    type: 'header',
    title: 'Upstream Coding',
    body: `
[upstreamcoding.com](https://upstreamcoding.com?ref=portfolio)

Co-founder, Teacher
    `,
    dates: 'Jun 2018 - Feb. 2022',
    orientation: 'right'
  },
  {
    type: 'nontimeline',
    title: 'Learning Management Platform',
    orientation: 'right',
    projects: [
      {
        title: 'Student Portal',
        screens: [
          {
            img: 'imgs/projects/upstream-coding/upstream-coding-student-portal.png',
            body: 'Designed & built a central hub for instructors and students with React and Firebase. Built many integrations with Contentful APIs allows instructors to write curriculum in Markdown in a friendly CMS GUI and Calendly and Stripe handle scheduling and seamless payment processing.'
          }
        ]
      }
    ]
  },
  {
    type: 'nontimeline',
    title: 'Marketing Website',
    orientation: 'right',
    projects: [
      {
        title: 'Marketing Website',
        screens: [
          {
            img: 'imgs/projects/upstream-coding/upstream-coding--marketing-website.png',
            body: 'Designed & built a marketing site with Jekyll and Bootstrap 4. API integrations with Eventbrite, HotJar, Mailchimp, Calendly, Stripe and Google Apps Script capture user engagement and automate responses.'
          }
        ]
      }
    ]
  },
  {
    type: 'header',
    title: 'i.am+',
    body: 'Sn. Software Engineer, Frontend',
    dates: 'Feb. 2015 - May 2019',
    orientation: 'right'
  },
  {
    type: 'nontimeline',
    title: 'Omega Web',
    body: 'React + Web Audio APIs',
    orientation: 'right',
    projects: [
      {
        title: 'Omega Web',
        screens: [
          {
            img: 'imgs/projects/omega-web/01--omega-web.png',
            body: 'Omega shows up as a small circle in the bottom left of the browser and tries to grab your attention with a chat bubble. Once a user enables their microphone, Omega will introduce her self using SpeechSynthesis and temporarily disable microphone recognition. After introductions, users can speak their questions and Omega will speak the answer based on the response from the i.am+ NLU.'
          }
        ]
      }
    ]
  },
  {
    id: "tinka",
    type: 'nontimeline',
    title: 'Tinka',
    body: '[t-mobile.at](https://www.t-mobile.at)',
    orientation: 'right',
    projects: [
      {
        title: 'Tinka',
        screens: [
          {
            img: 'imgs/projects/tinka/tinka-bubble.png',
            body: 'Tinka shows up as a small circle in the top right of the browser.'
          },
          {
            img: 'imgs/projects/tinka/tinka-bubble--tray.png',
            body: 'At a certain interval she will try to catch your attention by growing in size.'
          },
          {
            img: 'imgs/projects/tinka/tinka.png',
            body: 'Once you click Tinka and agree to the TOS, you can begin typing or click a button to get assistance with customer service related inquiries about T-mobile plans and devices.'
          }
        ]
      }
    ]
  },
  {
    type: 'header',
    title: 'CitizenGlobal',
    body: 'Sn. Software Engineer, Frontend',
    dates: 'Feb 2011 - Feb 2015',
    orientation: 'right',
  },
  {
    type: 'nontimeline',
    title: 'CitizenGlobal',
    orientation: 'right',
    projects: [
      {
        title: 'CitizenGlobal',
        screens: [
          {
            img: 'imgs/projects/citizenglobal/citizenglobal--marketing-website.png',
            body: 'Technologies used include JavaScript, jQuery, HTML, CSS and Skeleton.'
          },
          {
            img: 'imgs/projects/citizenglobal/citizenglobal--media.png',
            body: 'Built many features to manage thousands of media coming from body cameras, websites and social media APIs including annotation, bulk editing, filtering, sort and search.'
          },
          {
            img: 'imgs/projects/citizenglobal/citizenglobal--map.png',
            body: 'One of the more elaborate features was an integration with Google maps to allow law enforcement agents to set a pin, radius and collect media from popular social media sites during an emergency.'
          }
        ]
      }
    ]
  },
  {
    type: 'nontimeline',
    title: 'SendUs',
    orientation: 'right',
    projects: [
      {
        title: 'SendUs',
        screens: [
          {
            img: 'imgs/projects/sendus/sendus--marketing-website.jpg',
            body: 'Technologies used include JavaScript, jQuery, HTML, CSS and Skeleton.'
          },
          {
            img: 'imgs/products-sendus-tooltip.jpg',
            body: 'Built an onboarding walkthrough to guide user through key features in the interface. I worked closely with the design and product teams to create and refine an ever evolving setup process.'
          },
          // {
          //   img: 'imgs/products-sendus-dashboard.jpg',
          //   body: 'A dashboard is crucial to the success of any SASS product. I worked closely with the product team to create wireframes and engineer an interface to concisely display multiple sophisticated features on a single screen.'
          // },
          {
            img: 'imgs/products-sendus-media.jpg',
            body: 'Built numerous features to streamline the process of managing the thousands of media including a chat window, folders, tagging and bulk editing options.'
          },
          {
            img: 'imgs/products-sendus-review-queue.jpg',
            body: 'One of the more elaborate features called the Review Queue, enables users to review media simultaneously without impeding the progress of others.'
          },
          // {
          //   img: 'imgs/products-sendus-analytics.jpg',
          //   body: 'Analytics are crucial to the success of any SASS product. Users need to understand, at the macro and micro level, what activity is happening so they can be be informed and make better decisions.'
          // },
          // {
          //   img: 'imgs/products-sendus-widgets.jpg',
          //   body: 'From wireframes to execution, I engineered how users create and manage our many web based applications (widgets). In addition to the management interface, I was also on the team which engineered the photo editor depicted above.'
          // }
        ]
      }
    ]
  },
  {
    type: 'header',
    title: 'Breaking Development',
    body: 'Co-founder, Software Engineer, Frontend',
    dates: 'Feb 2011 - Feb 2015',
    orientation: 'right'
  },
  {
    type: 'header',
    title: 'Freelance',
    body: "I'm always open to working on interesting projects.",
    dates: 'Feb 2009 - Current',
    orientation: 'right'
  },
  {
    type: 'nontimeline',
    title: 'Consular.ai',
    body: `[consular.ai](https://consular.ai)`,
    dates: '2018',
    orientation: 'right',
    projects: [
      {
        title: 'Consular.ai',
        screens: [
          {
            img: 'imgs/projects/consular-ai/consular-ai.png',
            body: 'Reduced the volume of phone calls to Kazakhstan Embassies in the U.S. by 20% by building a React SPA that guides users through TypeForm style screens to determine if they need a visa for their upcoming travel.'
          }
        ]
      }
    ]
  },
  {
    type: 'nontimeline',
    title: 'TrainerScript',
    body: 'Ember, Bootstrap 4, Stripe',
    dates: '2017',
    orientation: 'right',
    projects: [
      {
        title: 'Consular.ai',
        screens: [
          {
            img: 'imgs/projects/trainerscript/trainerscript-admin-panel.png',
            body: 'Designed & built an Ember SPA to support an affiliate program for nutritional supplements which integrated with Stripe Api for payments.'
          }
        ]
      }
    ]
  },
  {
    type: 'header',
    title: 'More career details',
    body: `[linkedin.com/in/alanmabry](https://www.linkedin.com/in/alanmabry)`,
    dates: '🙂',
    orientation: 'right'
  },
];

export default companies;
